import { render, staticRenderFns } from "./WorksnDetail.vue?vue&type=template&id=af1d0b84&scoped=true"
import script from "./WorksnDetail.vue?vue&type=script&lang=js"
export * from "./WorksnDetail.vue?vue&type=script&lang=js"
import style0 from "./WorksnDetail.vue?vue&type=style&index=0&id=af1d0b84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1d0b84",
  null
  
)

export default component.exports